export default __webpack_public_path__ + "_/sounds/money_sound-fe2eefc07b6664d56f0fa272df4b923e60c7bc8be9bdac685784d980e522c85c.mp3";